import {
  TelemetryChannel,
  TelemetryType,
} from '@tableau/microview-communication-service/lib/src/channelDefinitions/TelemetryChannelDefinitions';
import { ContentTypeFilterAllOption, ContentTypeFilterValue } from '../models/ContentTypeFilterValue';
import { PageType } from '../models/PageType';

export class TelemetryService {
  public static instance = new TelemetryService();
  private channel = new TelemetryChannel();

  public sendSearchResultClickedEvent(event: Omit<SearchResultClickedEvent, 'searchFlowId'>) {
    return this.channel.call({ bag: event, type: TelemetryType.ClickSearchResult });
  }

  public filtersUpdatedEvent(filterName: string, actionType: FilterAction, contentType: ContentTypeFilterValue, searchTerm?: string) {
    const pageType = (contentType === ContentTypeFilterAllOption ? PageType.mixed : PageType.single).toString();
    switch (actionType) {
      case FilterAction.Added:
        return this.channel.call({
          bag: { pageType, searchTerm, contentType: contentType.toString(), added: filterName },
          type: TelemetryType.FilterSearch,
        });
      case FilterAction.Removed:
        return this.channel.call({
          bag: { pageType, searchTerm, contentType: contentType.toString(), removed: filterName },
          type: TelemetryType.FilterSearch,
        });
      case FilterAction.Updated:
        return this.channel.call({
          bag: { pageType, searchTerm, contentType: contentType.toString(), updated: filterName },
          type: TelemetryType.FilterSearch,
        });
      default:
        return null;
    }
  }

  public sortEvent(field: string, contentType: ContentTypeFilterValue, ascending = true, eventSource = 'dropdown') {
    const pageType = (contentType === ContentTypeFilterAllOption ? PageType.mixed : PageType.single).toString();
    return this.channel.call({
      bag: { pageType, contentType: contentType.toString(), field, ascending, eventSource },
      type: TelemetryType.SortSearch,
    });
  }
}

export enum FilterAction {
  Added = 'added',
  Removed = 'removed',
  Updated = 'updated',
}

interface SearchResultClickedEvent {
  type: string;
  eventSource: string;
  resultType: string;
  seeAll: boolean;
  index: number;
  total: number;
  searchTerm: string;
  contentId: string;
  searchFlowId: string;
}
